
import React from 'react';
import { FooterCompanyInfo } from './footer/FooterCompanyInfo';
import { FooterProductLinks } from './footer/FooterProductLinks';
import { FooterCompanyLinks } from './footer/FooterCompanyLinks';
import { FooterLegalLinks } from './footer/FooterLegalLinks';
import { FooterBottomBar } from './footer/FooterBottomBar';

export const Footer = () => {
  return (
    <footer id="footer-section" className="bg-gray-900 text-white text-sm">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 md:gap-6 lg:gap-8">
          <FooterCompanyInfo />
          <FooterProductLinks />
          <FooterCompanyLinks />
          <FooterLegalLinks />
        </div>
      </div>

      <FooterBottomBar />
    </footer>
  );
};
